import {
  Popover,
  PopoverButton,
  PopoverPanel,
  useClose,
} from "@headlessui/react";
import { columnDataTypes } from "../helpers";
import { rulesProperties } from "../helpers";
import { optionsForInputColumn } from "../helpers";
import { deleteMappings, setEditStateData } from "../store/workspaceSlice";
import { useDispatch } from "react-redux";
import { showConfirmDelete } from "../helpers";
const ViewMappings = ({ column, index }) => {
  const dispatch = useDispatch();
  let close = useClose();

  const deleteData = (colId, mappingsName) => {
    showConfirmDelete(
      mappingsName,
      () => {
        dispatch(deleteMappings(colId));
      },
      close
    );
    close();
  };

  return (
    <Popover key={index}>
      <PopoverButton
        onPointerDown={(e) => e.stopPropagation()} // Prevents drag from interfering with the popover
        className=" w-full flex justify-between items-center p-2 bg-white border rounded-md shadow-sm hover:bg-gray-200 hover:cursor-pointer outline-none focus:border-red-500"
      >
        <span className="font-medium text-gray-700">
          {/* handling type of rule */}
          {rulesProperties[column?.appliedRule]?.ruleName ||
            column?.ruleName ||
            column.inputColumn ||
            column.outColChr}
          {column?.selectOptionFromInput &&
            ` (${optionsForInputColumn[column?.selectOptionFromInput]})`}
        </span>
        <span className="text-sm text-gray-500">Id: {column._id}</span>
      </PopoverButton>
      <PopoverPanel transition anchor="left" className="rounded-lg">
        <div className="p-3 w-300 max-w-md bg-gray-500">
          <div className="flex flex-col  divide-y divide-dashed rounded-lg py-2 px-3 transition hover:bg-white/5 font-semibold text-white">
            {column?.outputColumnHeader && (
              <div className="grid grid-cols-2 gap-4">
                <span>Column Header</span>
                <span className="text-white/70">
                  {column.outputColumnHeader}
                </span>
              </div>
            )}

            {/* heading */}
            <div className="grid grid-cols-2 mb-2 ">
              <span className="text-center col-span-2">Mappings </span>
            </div>

            {/* Show rule input column */}
            {column?.dateColumn && (
              <div className="grid grid-cols-2 gap-4">
                <span>Date Column </span>
                <span className="text-white/70">{`${column?.dateColumn} : ${column?.dateColumnType}`}</span>
              </div>
            )}
            {/* Show Aggregate Column  */}
            {column?.aggregateColumn && (
              <div className="grid grid-cols-2 gap-4">
                <span>Aggregate Column</span>
                <span className="text-white/70">{`${column?.aggregateColumn}`}</span>
              </div>
            )}
            {/* Show Aggregate Column  */}
            {column?.outputTargetCol?.length >= 1 && (
              <div className="grid grid-cols-2 gap-4">
                <span>Output target Column</span>
                <span className="text-white/70">{`${column?.outputTargetCol}`}</span>
              </div>
            )}
            {/* dateColumn and Date Column type */}
            {column?.inputColumn && (
              <div className="grid grid-cols-2 gap-4">
                <span>Input Column </span>
                <span className="text-white/70">{column?.inputColumn}</span>
              </div>
            )}
            {/* input columns array */}
            {column?.inputColumns?.length > 0 && (
              <div className="grid grid-cols-2 gap-4">
                <span>Input Columns </span>
                <span className="text-white/70">
                  {column?.inputColumns.join(",")}
                </span>
              </div>
            )}
            {/* output columns array */}
            {column?.outputColumns?.length > 0 && (
              <div className="grid grid-cols-2 gap-4">
                <span>Output Columns </span>
                <span className="text-white/70">
                  {column?.outputColumns.join(",")}
                </span>
              </div>
            )}
            {/* GroupBy columns array */}
            {column?.grpByCol?.length > 0 && (
              <div className="grid grid-cols-2 gap-4">
                <span>GroupBy Columns </span>
                <span className="text-white/70">
                  {column?.grpByCol.join(",")}
                </span>
              </div>
            )}

            {/* Group by column mappings */}
            {column?.grpByColMappings && (
              <div className="grid grid-cols-2 gap-4">
                <span>Map Columns</span>
                <span className="text-white/70">
                  {Object.entries(column.grpByColMappings).map(
                    ([key, value]) => `[${key} : ${value}] `
                  )}
                </span>
              </div>
            )}
            {/* Switch column mappings */}
            {column?.switchColMappings && (
              <div className="grid grid-cols-2 gap-4">
                <span>Map Columns</span>
                <span className="text-white/70">
                  {Object.entries(column.switchColMappings).map(
                    ([key, value]) => `[${key} : ${value}] `
                  )}
                </span>
              </div>
            )}
            {/* Custom column mappings */}
            {column?.customColumnMappings && (
              <div className="grid grid-cols-2 gap-4">
                <span>Map Columns</span>
                <span className="text-white/70">
                  {Object.entries(column.customColumnMappings).map(
                    ([key, value]) => `[${key} : ${value}] `
                  )}
                </span>
              </div>
            )}
            {/* Custom column mappings */}
            {column?.columnMappings && (
              <div className="grid grid-cols-2 gap-4">
                <span>Map Columns</span>
                <span className="text-white/70">
                  {Object.entries(column.columnMappings).map(
                    ([key, value]) => `[${key} : ${value}] `
                  )}
                </span>
              </div>
            )}
            {/* Aggregate column mappings */}
            {column?.aggregateMappings && (
              <div className="grid grid-cols-2 gap-4">
                <span>Map Columns</span>
                <span className="text-white/70">
                  {Object.entries(column.aggregateMappings).map(
                    ([key, value]) => `[${key} : ${value}] `
                  )}
                </span>
              </div>
            )}

            {/* Show rule input column */}
            {column?.mergeTo && (
              <div className="grid grid-cols-2 gap-4">
                <span>Merge To </span>
                <span className="text-white/70">{column?.mergeTo}</span>
              </div>
            )}
            {/* Show rule input column */}
            {column?.findType && (
              <div className="grid grid-cols-2 gap-4">
                <span>Column Type </span>
                <span className="text-white/70">
                  {columnDataTypes[column?.findType]}
                </span>
              </div>
            )}
            {/* Merge File Destination */}
            {column?.mergeDestination && (
              <div className="grid grid-cols-2 gap-4">
                <span>Merge File Destination </span>
                <span className="text-white/70">
                  {column?.mergeDestination}
                </span>
              </div>
            )}

            {/* Use Options from input Column, DueDate, Description, Contact Name*/}
            {column?.selectOptionFromInput && (
              <div className="grid grid-cols-2 gap-4">
                <span>Use input option </span>
                <span className="text-white/70">
                  {optionsForInputColumn[column?.selectOptionFromInput] ||
                    column?.selectOptionFromInput}
                </span>
              </div>
            )}
            {/* Show rule input column */}
            {column?.outputColumn && (
              <div className="grid grid-cols-2 gap-4">
                <span>Output Column </span>
                <span className="text-white/70">{column?.outputColumn}</span>
              </div>
            )}

            {/* Date Format */}
            {column?.toDateFormat && (
              <div className="grid grid-cols-2 gap-4">
                <span>Date Format </span>
                <span className="text-white/70">{column?.toDateFormat}</span>
              </div>
            )}

            {/* Clone Column */}
            {column?.cloneColumn && (
              <div className="grid grid-cols-2 gap-4">
                <span>Clone Column </span>
                <span className="text-white/70">{column?.cloneColumn}</span>
              </div>
            )}

            {/* date mask */}
            {(column?.dateMask || column?.mask) && (
              <div className="grid grid-cols-2 gap-4">
                <span>Mask </span>
                <span className="text-white/70">{column?.mask}</span>
              </div>
            )}
            {/* date source column details */}
            {column?.dateCol && (
              <div className="grid grid-cols-2 gap-4">
                <span>Get date from column </span>
                <span className="text-white/70">{column?.dateCol}</span>
              </div>
            )}
            {/* Add number of days in new column */}
            {column?.dateDays && (
              <div className="grid grid-cols-2 gap-4">
                <span>Add number of days </span>
                <span className="text-white/70">{column?.dateDays}</span>
              </div>
            )}
            {/* applied rule */}
            {column?.appliedRule && (
              <div className="grid grid-cols-2 gap-4">
                <span>Applied Rule</span>
                <span className="text-white/70">
                  {rulesProperties[column?.appliedRule].ruleName || ""}{" "}
                  {column?.selectedAction && `(${column?.selectedAction})`}
                </span>
              </div>
            )}
            {/* applied rule */}
            {column?.useOutputOf && (
              <div className="grid grid-cols-2 gap-4">
                <span>Use output of</span>
                <span className="text-white/70">{column?.useOutputOf}</span>
              </div>
            )}
            {/* Apply rule on entire row */}
            {column?.entireRow !== undefined && (
              <div className="grid grid-cols-2 gap-4">
                <span>Skip Entire Row</span>
                <span className="text-white/70">
                  {column?.entireRow ? "True" : "False"}
                </span>
              </div>
            )}
            {/* Skip  empty cells */}
            {column?.skipEmptyCells !== undefined && (
              <div className="grid grid-cols-2 gap-4">
                <span>Skip Empty Cells</span>
                <span className="text-white/70">
                  {column?.skipEmptyCells ? "True" : "False"}
                </span>
              </div>
            )}
            {/* Skip  empty cells */}
            {column?.skipZeroValues !== undefined && (
              <div className="grid grid-cols-2 gap-4">
                <span>Skip 0 Values</span>
                <span className="text-white/70">
                  {column?.skipZeroValues ? "True" : "False"}
                </span>
              </div>
            )}
            {/* Apply rule on entire row */}
            {column?.skipCondition && (
              <div className="grid grid-cols-2 gap-4">
                <span>Skip Condition</span>
                <span className="text-white/70">{column?.skipCondition}</span>
              </div>
            )}
            {/* Duplicate number of times */}
            {(column?.duplicateNTimes || column?.duplicateNTimes === 0) && (
              <div className="grid grid-cols-2 gap-4">
                <span>Duplicate </span>
                <span className="text-white/70">{`${column?.duplicateNTimes} Times`}</span>
              </div>
            )}
            {/* show ranges type */}
            {column?.ranges !== undefined && (
              <div className="grid grid-cols-2 gap-4">
                <span>Find Ranges</span>
                <span className="text-white/70">
                  {column.ranges ? "True" : "False"}
                </span>
              </div>
            )}
            {/* show Character Codes mappings */}
            {column?.charCodes && (
              <div className="">
                <ul className="list-disc list-inside max-h-40 min-h-30 overflow-y-auto p-2 divide-y-2">
                  {column.charCodes.map((data, index) => (
                    <li
                      key={index}
                      className="flex justify-between items-center P-2 my-1"
                    >
                      <span>
                        "Character code for{" "}
                        <span className="font-bold">{data[0]}</span> is{" "}
                        <span className="font-bold">{data[1]}</span>
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            )}
            {/* Fin-tech function */}
            {/* Description Column location */}
            {column?.descriptionColumn && (
              <div className="grid grid-cols-2 gap-4">
                <span>Description Column </span>
                <span className="text-white/70">
                  {column?.descriptionColumn}
                </span>
              </div>
            )}
            {/* Account Column location */}
            {column?.accountColumn && (
              <div className="grid grid-cols-2 gap-4">
                <span>Account Column </span>
                <span className="text-white/70">{column?.accountColumn}</span>
              </div>
            )}
            {/* Debit Column location */}
            {column?.debitColumn && (
              <div className="grid grid-cols-2 gap-4">
                <span>Debit Column </span>
                <span className="text-white/70">{column?.debitColumn}</span>
              </div>
            )}
            {/* Credit Column location */}
            {column?.creditColumn && (
              <div className="grid grid-cols-2 gap-4">
                <span>Credit Column </span>
                <span className="text-white/70">{column?.creditColumn}</span>
              </div>
            )}
            {/* Credit Column location */}
            {column?.searchValue && (
              <div className="grid grid-cols-2 gap-4">
                <span>Search </span>
                <span className="text-white/70">{column?.searchValue}</span>
              </div>
            )}
            {/* Credit Column location */}
            {column?.exclusiveStartDate && (
              <div className="grid grid-cols-2 gap-4">
                <span>Exclusive Start Date</span>
                <span className="text-white/70">
                  {column?.exclusiveStartDate ? "True" : "False"}
                </span>
              </div>
            )}
            {/* Credit Column location */}
            {column?.currency?.length >= 1 && (
              <div className="grid grid-cols-2 gap-4">
                <span>Currencies </span>
                <span className="text-white/70">
                  {column?.currency.map((item, i) => `${item} `)}
                </span>
              </div>
            )}
          </div>
        </div>

        <div className="p-2 bg-gray-400 flex justify-end">
          <button
            onPointerDown={(e) => e.stopPropagation()}
            onClick={() =>
              deleteData(
                column._id,
                rulesProperties[column?.appliedRule].ruleName
              )
            }
            className="px-2 py-1 bg-red-400 hover:bg-red-500 rounded-md text-white font-medium active:bg-red-700 transition-all duration-200"
          >
            Delete
          </button>

          <button
            onClick={() => {
              dispatch(
                setEditStateData({
                  data: { ...column },
                  type: rulesProperties[column?.appliedRule]?.actionName,
                  editMode: true,
                })
              );
            }}
            onPointerDown={(e) => e.stopPropagation()}
            className="px-2 py-1 bg-blue-400 hover:bg-blue-500 rounded-md text-white font-medium active:bg-blue-700 transition-all duration-200 ml-2"
          >
            Edit
          </button>
        </div>
      </PopoverPanel>
    </Popover>
  );
};

export default ViewMappings;
